module.exports = __webpack_public_path__ + "105cf1b33c35529c2f4cff4068251551.svg";